/*
直接更新state的多个方法的对象
 */
import { RECEIVE_USER_INFO, RESET_USER_INFO } from './mutation-types'

export default {
    [RECEIVE_USER_INFO](state, { userInfo }) {
        state.userInfo = userInfo
    },
    [RESET_USER_INFO](state) {
        state.userInfo = {}
    },

    // 已有账号绑定微信还是新账号注册微信
    existingAccountBindFun(state, playload) {
        // console.log(state, "已有账号绑定微信还是新账号注册微信");
        state.existingAccountBindWeiXin = playload
    },
    // 用来存储是否开启 微信或者QQ授权后 输入电话号 摊床框
    BindPhone(state, playload) {
        state.BindPhone = playload
    },
    changeLoginTrue(state) {
        state.isLogin = 'true'
        sessionStorage.setItem('login', 'true')
    },
    changeLoginFalse(state) {
        state.isLogin = 'false'
        sessionStorage.setItem('login', 'false')
    },
    // 保存用户信息的方法
    userNameFun(state, data) {
        state.userWeixin.nickname = data.username //用户名
        state.userWeixin.phone = data.phone //手机号
        state.userWeixin.openApplet = data.openApplet // 是否有小程序
        state.userWeixin.avatar = data.avatar // 用户头像
    },
    saveLicense(state, _license) {
        state.license = _license
    },
    saveClientele(state, _clientele) {
        state.clientele = _clientele
    },
    // saveIp(state, _ip) {
    //   state.ip = _ip;
    // },
    // saveAddress(state, _address) {
    //   state.address = _address;
    // },
}
